import { IContent } from 'models/content.model';

import ProposalType from './proposal-type.enum';

export const content: IContent = {
  nl: {
    page: {
      [ProposalType.Zapper]: {
        title: 'Voor de altijd zenders-zapper',
        text: "Omdat jij graag lekker op de bank zit en langs verschillende zenders zapt, hebben we het volgende voorstel voor je. Bekijk 'm rustig voordat je beslist.",
      },
      [ProposalType.Streamer]: {
        title: 'Voor de altijd series-kijker',
        text: "Omdat jij graag een lekkere serie of film streamt, hebben we het volgende voorstel voor je. Bekijk 'm rustig voordat je beslist.",
      },
      [ProposalType.AltijdAlles]: {
        title: 'Voor de altijd alles-kijker',
        text: 'Filmpje kijken op Disney+ of gewoon lekker zappen op de bank?. Met dit speciale voorstel voor jou, kan het allemaal.',
      },
    },
    proposals: {
      disney: {
        title: 'Disney+ met reclame #{months} maanden gratis',
        text: 'Geniet van de nieuwste films & series en je favoriete klassiekers, allemaal op één plek. Het Disney+ aanbod kijk je makkelijk via je Next Mini en Mediabox Next. Start Disney+ via het menu of ga naar kanaal 155 op je tv.',
        cta: 'Bekijk deze deal',
      },
      film1: {
        title: 'Film1 #{months} maanden gratis',
        text: 'Bij Film1 kijk je onbeperkt en reclamevrij de nieuwste titels en de grootste Nederlandse films. Op vier kanalen met een vaste programmering of on demand op je tv, tablet of smartphone.',
        cta: 'Bekijk deze deal',
      },
      tvChannel: {
        title: 'TV Zender+ #{months} maanden gratis',
        text: 'Geniet van de nieuwste films & series en je favoriete klassiekers, allemaal op één plek. Het Disney+ aanbod kijk je makkelijk via je Next Mini en Mediabox Next. Start Disney+ via het menu of ga naar kanaal 155 op je tv.',
        cta: 'Bekijk deze deal',
      },
      discount: {
        title: '#{months} maanden #{price} korting op je factuur',
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        cta: 'Bekijk deze deal',
      },
    },
  },
  en: {},
};
